import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {TaxCodeContainerModel} from '../../../../../../models/aggregates/erp/tax';
import {Core2Config} from '../../shared/core2Config';


@Injectable({
  providedIn: 'root'
})
export class TaxCodeCfgService extends BaseApiTemplateService<TaxCodeContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'tax-code-cfg';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'tax-code-cfg';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'tax-code-cfg';
    this.httpClient = http;
  }
}
